import React, { useEffect, useMemo, useRef, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import { toast } from "react-toastify";
import ScrollableReactTable from "@components/ScrollableDatatable";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import Notfound from "@components/Not-Found";
import moment from "moment";
import { adminBulkLocationUpdateStatus } from "@services/location.service";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import {
  exportManageAudit,
  generateManageAuditVendorReport,
  getManageAuditScore,
  getManageAuditScoreFilter,
  auditReportSummary,
} from "@services/audit.service";
import "./Audit.scss";
import CalenderDropdown from "@_common/CalenderDropdown";
import ManageAuditFilterForm from "@components/common/ManageAuditFilterForm";
import { formatText } from "@_common/format-text";
import { useParams } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { convertDate, currentDate } from "@_common/date-helpers";
import { tableScoreColors } from "@_common/colors";
import { countKeysWithValues, numberFormatter } from "@_common/text-helpers";
//graph module
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  adminGetCitiesListManagement,
  adminGetCountriesListManagement,
  adminGetStatesListManagement,
} from "@services/list-management.service";
import FooterWrapper from "@components/common/FooterWrapper";
import MenuAuditSvgComponent from "../../../assets/svg-components/left-menu/menuadit";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import ManageAuditNotfound from "@components/Page-Not-Found/manage-audit-not-found";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { DownloadTypeEnum } from "@utils/general.enum";
import { Download } from "lucide-react";
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ChartDataLabels
);
interface IManageAuditProps {}

const DownloadActionCell = ({
  vendorId,
  locationId,
  downloadLoading,
  handleDownloadReport,
}: {
  vendorId: string;
  locationId: string;
  downloadLoading: boolean;
  handleDownloadReport: any;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = (e: any) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  return (
    // <div
    //   className={`download-wrapper ${isOpen ? "open" : ""}`}
    //   ref={containerRef}
    // >
    //   <button className="download-button" onClick={toggleDropdown}>
    //     Download Report
    //   </button>

    //   <div className="download-menu">
    //     <button
    //       className="download-option"
    //       onClick={(e) => {
    //         setIsOpen(false);
    //         handleDownloadReport(
    //           e,
    //           vendorId,
    //           locationId,
    //           DownloadTypeEnum.PDF
    //         );
    //       }}
    //     >
    //       <img src="/pdf.svg" alt="PDF" />
    //       <span>PDF</span>
    //     </button>

    //     <button
    //       className="download-option"
    //       onClick={(e) => {
    //         setIsOpen(false);
    //         handleDownloadReport(
    //           e,
    //           vendorId,
    //           locationId,
    //           DownloadTypeEnum.EXCEL
    //         );
    //       }}
    //     >
    //       {/* <img src="/xls.svg" alt="Excel" /> */}
    //                 <img src="/xls.svg" alt="PDF" />

    //       <span>Excel</span>
    //     </button>
    //   </div>
    // </div>
    <div className="download-icons">
  <button
    className="icon-btn"
    onClick={(e) =>
      handleDownloadReport(
        e,
        vendorId,
        locationId,
        DownloadTypeEnum.PDF
      )
    }
    title="Download PDF"
  >
    <img src="/pdf.svg" alt="PDF" />
  </button>

  <button
    className="icon-btn"
    onClick={(e) =>
      handleDownloadReport(
        e,
        vendorId,
        locationId,
        DownloadTypeEnum.EXCEL
      )
    }
    title="Download Excel"
  >
    <img src="/xls.svg" alt="Excel" />
  </button>
</div>
  );
};

const ManageAuditLocations: React.FunctionComponent<IManageAuditProps> = (
  props: any
) => {
  let navigate = useNavigate();
  let mainParams = useParams();
  /* -------------------------------------------------------------------------- */
  /*                                UseState Section                            */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  
  const [isOpen, setIsOpen] = useState(false);
const dropdownRef = useRef(null);// Moved up here

  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };
  /* -------------------------------------------------------------------------- */
  /*                                UseEffect Section                           */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      setDate(new Date());
      getRegionsList("", "");
    }
    getInfo();
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();

      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
      //-----------------region & group-----------------//
      if (getValue(params, `region_id`, "")) {
        getRegionsList("", getValue(params, `region_id`, ""));
        getGroupsList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, "")
        );
      } else {
        getRegionsList("", getValue(params, `region_id`, ""));
      }

      //-----------------state-----------------//

      if (getValue(params, `group_id`, "")) {
        getStatesList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, "")
        );
      }

      //-----------------city-----------------//

      if (getValue(params, `state_id`, "")) {
        getCitiesList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, ""),
          getValue(params, `city_id`, "")
        );
      }

      //-----------------location-----------------//
      if (getValue(params, `group_id`, "")) {
        getLocationsList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, "")
        );
      }
      //-----------------vendor-----------------//
      if (getValue(params, `location_id`, "")) {
        getVendorList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          getValue(params, `vendor_id`, "")
        );
      }
      //-----------------audit type-----------------//
      if (getValue(params, `vendor_id`, "")) {
        getAuditTypeList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          getValue(params, `vendor_id`, ""),
          getValue(params, `audit_type`, "")
        );
      }

      setRequest({
        ...request,
        region_id: getValue(params, `region_id`, ""),
        group_id: getValue(params, `group_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        city_id: getValue(params, `city_id`, ""),
        location_id: getValue(params, `location_id`, ""),
        vendor_id: getValue(params, `vendor_id`, ""),
        audit_type: getValue(params, `audit_type`, ""),
      });
      if (getValue(params, `region_id`, "")) {
        setFilterVisibility(true);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                                API Section                                */
  /* -------------------------------------------------------------------------- */

  const [selectedOption, setSelectedOption] = useState({});
  const getInfo = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: params.region_id,
        // group_id: params.group_id,
        // type: "GROUP",
        type: params.view_type === "VENDOR" ? "VENDOR" : "GROUP",
        ...(params.view_type === "VENDOR"
          ? { vendor_id: params.vendor_id }
          : { group_id: params.group_id }),
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        // setSelectedOption(getValue(resp, `data.vendors_checkpoint[${0}]`, {}));
        if (resp) {
          if (params.group_id) {
            setSelectedOption(
              getValue(resp, `data.vendors_checkpoint[${0}]`, {})
            );
          } else if (params.vendor_id) {
            setSelectedOption(
              getValue(resp, `data.vendors_checkpoint[${0}]`, {})
            );
          } else {
            setSelectedOption({ group_id: 0, group_name: "All" });
          }
        }
      }
    } catch (error) {}
  };

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      type: params.type ? params.type : "LOCATION",
      audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: true,
      user_id: getValue(user, `id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getManageAuditScore(queryRequest);
      if (resp) {
        //------------------- Graph Section starts -------------------//
        let labelArray = getValue(resp, `data`, []).map(
          (item: any) => item.location_name
        );
        let siteArray = getValue(resp, `data`, []).map((item: any) =>
          parseInt(item.location)
        );
        let vendorArray = getValue(resp, `data`, []).map((item: any) =>
          parseInt(item.vendor)
        );
        // let headcount = getValue(resp, `data`, []).map((item: any) =>
        //   parseInt(item.manpower)
        // );
        let scoreArray = getValue(resp, `data`, []).map(
          (item: any) => `${parseFloat(item.score)}`
        );
        setValue(chartData, `labels`, labelArray);
        // setValue(chartData, `datasets[${0}].data`, siteArray);
        setValue(chartData, `datasets[${0}].data`, vendorArray);
        // setValue(chartData, `datasets[${2}].data`, headcount);
        setValue(chartData, `datasets[${1}].data`, scoreArray);
        setChartData({ ...chartData });

        //------------------- Graph Section Ends -------------------//

        setList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            created_at: moment(getValue(item, `created_at`, "")).format(
              "DD MMM YYYY"
            ),
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            city_name: getValue(item, `city.name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                Search section                              */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                            Pagination section                              */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const rowClick = (row: object) => {
    navigate();
    // `/audit/manage-audit/vendor?${mainQueryRequest}`
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };

  const handleDownloadReport = async (
    e: any,
    vendor_id: string,
    location_id: string,
    downloadType: DownloadTypeEnum = DownloadTypeEnum.EXCEL
  ) => {
    e.stopPropagation();
    if (downloadLoading) return;

    try {
      setDownloadLoading(true);
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = date ? date : new Date();

      let payload: any = {
        report_type: "VENDOR_AUDIT_SCORE",
        report_name: `vendor_audit_score_${currentDate()}`,
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: params.region_id,
        group_id: params.group_id,
        location_id: location_id,
        vendor_id: vendor_id,
        audit_type: params.audit_type,
        download_type: downloadType === DownloadTypeEnum.PDF ? DownloadTypeEnum.PDF : DownloadTypeEnum.EXCEL,
      };
      payload.month = parseInt(payload.month);
      payload.region_id = parseInt(payload.region_id);

      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let resp = await generateManageAuditVendorReport(payload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/VENDOR_AUDIT_SCORE`);
      }
    } catch (error) {
    } finally {
      setDownloadLoading(false);
    }
  };

  const handleDownloadAuditSummary = async (
    e: any,
    vendor_id?: string,
    location_id?: string
  ) => {
    e.stopPropagation();
    if (downloadLoading) return;

    try {
      setDownloadLoading(true);
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = date ? date : new Date();

      let payload: any = {
        report_type: "AUDIT_REPORT_SUMMARY",
        report_name: `audit_report_summary_${currentDate()}`,
        month: params.date
          ? parseInt(params.date.split("-")[1], 10)
          : date
          ? parseInt(moment(date).format("MM"), 10)
          : parseInt(moment(dates).format("MM"), 10),
        year: params.date
  ? parseInt(params.date.split("-")[0], 10)
  : date
  ? parseInt(moment(date).format("YYYY"), 10)
  : parseInt(moment(dates).format("YYYY"), 10),

        location_id: location_id ? String(location_id) : undefined,
        vendor_id: vendor_id || params.vendor_id ? String(vendor_id || params.vendor_id) : undefined,
      };

      Object.keys(payload).forEach((key) => {
        if (payload[key] === undefined || payload[key] === null || payload[key] === "") {
          delete payload[key];
        }
      });
      let resp = await auditReportSummary(payload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/AUDIT_REPORT_SUMMARY`);
      }
    } catch (error) {
    } finally {
      setDownloadLoading(false);
    }
  };

  const searchParams = new URLSearchParams(window.location.search);
  const paramsNew = Object.fromEntries(searchParams.entries());

  const dateParam = paramsNew?.date ? new Date(paramsNew.date) : new Date(); // Get the date from params or use the current date
  // Helper function to get the month name for a given date
  // const getMonthName = (date: Date, offset: number) => {
  //   const adjustedDate = new Date(date);
  //   adjustedDate.setMonth(date.getMonth() - offset); // Subtract months to get the previous month
  //   return adjustedDate.toLocaleString("default", { month: "short" }); // Get month name
  // };

  // const currentMonthName = getMonthName(dateParam, 0);
  // const prevMonth1Name = getMonthName(dateParam, 1);
  // const prevMonth2Name = getMonthName(dateParam, 2);
  // const prevMonth3Name = getMonthName(dateParam, 3);

  const getMonthNameWithYear = (date: Date, offset: number) => {
    const adjustedDate = new Date(date);
    adjustedDate.setMonth(date.getMonth() - offset); // Subtract months to get previous month
    const month = adjustedDate.toLocaleString("default", { month: "short" });
    const year = adjustedDate.getFullYear().toString().slice(-2);
    return `${month}-${year}`;
  };

  // Use the new function to get month-year combinations
  const currentMonthName = getMonthNameWithYear(dateParam, 0);
  const prevMonth1Name = getMonthNameWithYear(dateParam, 1);
  const prevMonth2Name = getMonthNameWithYear(dateParam, 2);
  const prevMonth3Name = getMonthNameWithYear(dateParam, 3);

  const columns = React.useMemo(
    () => [
      {
        Header: "Site Name",
        accessor: "location_name",
        width: 150,
        // Cell: ({ row }: any) => {
        //   return (
        //     <>
        //       <NavLink
        //         to={`/audit/manage-audit/vendor/${getValue(
        //           mainParams,
        //           `region_id`,
        //           ""
        //         )}/${getValue(params, `group_id`, "")}/${getValue(
        //           row,
        //           `original.location_id`,
        //           ""
        //         )}?${mainQueryRequest}`}
        //       >
        //         {row.values.location_name}
        //       </NavLink>
        //     </>
        //   );
        // },

        Cell: ({ row }: any) => {
          const location_id = row.original.location_id;
          // const updatedQueryRequest = mainQueryRequest
          // .split("&")
          // .filter(param => !param.startsWith("view_type="))
          // .join("&");

          // const finalQueryRequest = `${updatedQueryRequest}&location_id=${location_id}`;
          const view_type = params.view_type;
          const redirectTo =
            view_type === "VENDOR"
              ? "/audit/manage-audit/checkpoint"
              : "/audit/manage-audit/vendor";

          const updatedQueryRequest = `${mainQueryRequest}&location_id=${location_id}`;

          return (
            <NavLink to={`${redirectTo}?${updatedQueryRequest}`}>
              {row.values.location_name}
            </NavLink>
          );
        },
      },

      {
        // Header: "Overall Score",
        Header: `${currentMonthName} Score`,
        accessor: "score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.score`, 0)
                    ? parseFloat(getValue(row, `values.score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.score`, 0)
                ? getValue(row, `values.score`, 0)
                : 0}
              % */}
              {getValue(row, `values.score`, null) === null
                ? "- -"
                : `${getValue(row, `values.score`, 0)}%`}
            </div>
          );
        },
      },
      {
        // Header: "1MP Score",
        Header: `${prevMonth1Name} Score`,
        accessor: "prev_month_1_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_1_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_1_score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.prev_month_1_score`, 0) > 0
                ? `${getValue(row, `values.prev_month_1_score`, 0)}%`
                : "0%"} */}
              {getValue(row, `values.prev_month_1_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_1_score`, 0)}%`}
            </div>
          );
        },
      },
      {
        // Header: "2MP Score",
        Header: `${prevMonth2Name} Score`,
        accessor: "prev_month_2_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_2_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_2_score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.prev_month_2_score`, 0) > 0
                ? `${getValue(row, `values.prev_month_2_score`, 0)}%`
                : "0%"} */}
              {getValue(row, `values.prev_month_2_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_2_score`, 0)}%`}
            </div>
          );
        },
      },
      {
        // Header: "3MP Score",
        Header: `${prevMonth3Name} Score`,
        accessor: "prev_month_3_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_3_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_3_score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.prev_month_3_score`, 0) > 0
                ? `${getValue(row, `values.prev_month_3_score`, 0)}%`
                : "0%"} */}
              {getValue(row, `values.prev_month_3_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_3_score`, 0)}%`}
            </div>
          );
        },
      },
      {
        Header: "Vendors",
        accessor: "vendor",
        width: 80,
      },
      {
        Header: "Absent",
        accessor: "absent_sites",
        width: 100,
      },
      {
        Header: "Submited Checkpoint",
        accessor: "uploaded",
        width: 140,
      },
      {
        Header: "Not Submited Checkpoint",
        accessor: "not_uploaded",
        width: 160,
      },
      // {
      //   Header: "Submitted",
      //   accessor: "locations_all_submitted",
      //   width: 90,
      // },
      // {
      //   Header: "Partially Submitted",
      //   accessor: "locations_partial_submission",
      //   width: 130,
      // },
      // {
      //   Header: "Not Submitted",
      //   accessor: "locations_no_submission",
      //   width: 110,
      // },

      {
        Header: "Headcount",
        accessor: "manpower",
        width: 100,
        Cell: ({ row }: any) => {
          return (
            <div className="headcount-button">
              {getValue(row, `values.manpower`, 0)
                ? numberFormatter(getValue(row, `values.manpower`, 0))
                : 0}
            </div>
          );
        },
      },

      ...(paramsNew?.vendor_id
        ? [
            {
              Header: "Action",
              width: 150,
              Cell: ({ row }: any) => (
                <DownloadActionCell
                  vendorId={paramsNew.vendor_id}
                  locationId={row.original.location_id}
                  downloadLoading={downloadLoading}
                  handleDownloadReport={handleDownloadReport}
                />
              ),
            },
          ]
        : []),

      ...(getValue(props, "permissions", []).includes(
        "audit_summary_report"
      )
        ? [
            {
              Header: "Audit Summary",
              accessor: "audit_summary",
              width: 100,
              Cell: ({ row }: any) => (
                <div className="download-icons">
                  <button
                    className="icon-btn"
                    onClick={(e) =>
                      handleDownloadAuditSummary(
                        e,
                        row.original?.vendor_id || paramsNew?.vendor_id,
                        row.original?.location_id
                      )
                    }
                    title="Download Audit Summary"
                  >
                    <Download size={18} />
                  </button>
                </div>
              ),
            },
          ]
        : []),
    ],
    [paramsNew.date, paramsNew?.vendor_id, downloadLoading, props.permissions]

    
  );
  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await adminBulkLocationUpdateStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* -------------------------------------------------------------------------- */
  /*                                Date section                                */
  /* -------------------------------------------------------------------------- */

  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = moment(date).format("YYYY-MM-DD");
    if (dates && dates !== "Invalid date") {
      let payload: any = {
        ...params,
        date: dates,
      };

      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };

  const handleNavigate = (bodyObj: object) => {
    navigate(
      `/audit/details/${getValue(bodyObj, `vendor_id`, "")}/${moment(
        date
      ).format("YYYY-MM-DD")}/uploaded/${getValue(bodyObj, `vendor_name`, "")}`
    );
  };
  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let D = date ? date : new Date();
    let dates = params.date ? convertDate(params.date) : convertDate(D);
    let request = QueryRequestHelper({ ...params, date: dates });
    return request;
  };

  const mainQueryRequest = useMemo(
    () => urlParamsFun(),
    [window.location.href]
  );
  /* -------------------------------------------------------------------------- */
  /*                        smart Filter section                                */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    region_id: "",
    group_id: "",
    state_id: "",
    city_id: "",
    location_id: "",
    vendor_id: "",
    audit_type: "",
  });
  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    setRequest({
      ...request,
      state_id: "",
      city_id: "",
      region_id: "",
      group_id: "",
      location_id: "",
      vendor_id: "",
      audit_type: "",
    });
    setGroupsList([]);
    setStateList([]);
    setCityList([]);
    setlocationsList([]);
    setvendorsList([]);
    setAuditTypeList([]);
    //  setFilterVisibility(false);
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    setFilterVisibility(false);
  };

  const [isFilterVisible, setFilterVisibility] = React.useState(false);

  /* -------------------------------------------------------------------------- */
  /*                        smart Filter API section                            */
  /* -------------------------------------------------------------------------- */

  const [regionList, setRegionList] = useState([]);
  const [regionLoading, setRegionLoading] = useState(false);

  const getRegionsList = async (search_text: string, id: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        type: "REGION",
        search_text: search_text,
        region_id: id,
      };
      setRegionLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setRegionList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `region_id`, ""),
            label: getValue(item, `region_name`, ""),
            value: getValue(item, `region_name`, ""),
          }))
        );
        setRegionLoading(false);
      } else {
        setRegionLoading(false);
      }
    } catch (error) {
      setRegionLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   region_id: "",
      // });
      //   getGroupsList("", "");
      //   setGroupsList([]);
      //   getLocationsList("", "", "");
      //   setlocationsList([]);
      //   getVendorList("", "", "", "");
      //   setvendorsList([]);
    }
  };

  const [groupsList, setGroupsList] = useState([]);
  const [groupLoading, setGroupLoading] = useState(false);
  const getGroupsList = async (
    search_text: string,
    region_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: params.region_id,
        type: "GROUP",
        search_text: search_text,
        group_id: id,
      };
      setGroupLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setGroupsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `group_id`, ""),
            label: getValue(item, `group_name`, ""),
            value: getValue(item, `group_name`, ""),
          }))
        );
        setGroupLoading(false);
      } else {
        setGroupLoading(false);
      }
    } catch (error) {
      setGroupLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   group_id: null,
      // });
      //   getLocationsList("", "", "");
      //   setlocationsList([]);
      //   getVendorList("", "", "", "");
      //   setvendorsList([]);
    }
  };

  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const getStatesList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "STATE",
        search_text: search_text,
        state_id: id,
      };

      setStateLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setStateList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `state_id`, ""),
            label: getValue(item, `state_name`, ""),
            value: getValue(item, `state_name`, ""),
          }))
        );
        setStateLoading(false);
      } else {
        setStateLoading(false);
      }
    } catch (error) {
      setStateLoading(false);
    }
  };

  const [cityList, setCityList] = useState([]);
  const [cityLoading, setCityLoading] = useState(false);
  const getCitiesList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "CITY",
        search_text: search_text,
        state_id: state_id,
        city_id: id,
      };

      setCityLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setCityList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `city_id`, ""),
            label: getValue(item, `city_name`, ""),
            value: getValue(item, `city_name`, ""),
          }))
        );
        setCityLoading(false);
      } else {
        setCityLoading(false);
      }
    } catch (error) {
      setCityLoading(false);
    }
  };

  const [locationsList, setlocationsList] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const getLocationsList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "LOCATION",
        search_text: search_text,
        state_id: state_id,
        city_id: city_id,
        location_id: id,
      };
      setLocationLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setlocationsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `location_id`, ""),
            label: getValue(item, `location_name`, ""),
            value: getValue(item, `location_name`, ""),
          }))
        );
        setLocationLoading(false);
      } else {
        setLocationLoading(false);
      }
    } catch (error) {
      setLocationLoading(false);
    }

    if (search_text) {
      // setRequest({
      //   ...request,
      //   location_id: "",
      // });
      //   getVendorList("", "", "", "");
      //   setvendorsList([]);
    }
  };

  const [vendorsList, setvendorsList] = useState([]);
  const [vendorLoading, setvendorLoading] = useState(false);
  const getVendorList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        type: "VENDOR",
        search_text: search_text,
        vendor_id: id,
      };
      setvendorLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setvendorsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `vendor_id`, ""),
            label: getValue(item, `vendor_name`, ""),
            value: getValue(item, `vendor_name`, ""),
          }))
        );
        setvendorLoading(false);
      } else {
        setvendorLoading(false);
      }
    } catch (error) {
      setvendorLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   vendor_id: "",
      // });
    }
  };

  const [auditTypeList, setAuditTypeList] = useState([]);
  const [auditTypeLoading, setAuditTypeLoading] = useState(false);
  const getAuditTypeList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    vendor_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        vendor_id: vendor_id,
        type: "AUDIT_TYPE",
        search_text: search_text,
        audit_type: id,
      };
      setAuditTypeLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setAuditTypeList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `audit_status`, ""),
            label: formatText(getValue(item, `audit_status`, "")),
            value: getValue(item, `audit_status`, ""),
          }))
        );
        setAuditTypeLoading(false);
      } else {
        setAuditTypeLoading(false);
      }
    } catch (error) {
      setAuditTypeLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   vendor_id: "",
      // });
    }
  };

  const handleRemoveFilter = (name: string) => {
    if (name === "region_id") {
      setRequest({
        ...request,
        region_id: "",
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      getRegionsList("", "");
      setGroupsList([]);
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "group_id") {
      setRequest({
        ...request,
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getGroupsList("", getValue(params, `region_id`, ""), "");
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "state_id") {
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getStatesList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        ""
      );
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "city_id") {
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getCitiesList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        ""
      );
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "location_id") {
      setRequest({
        ...request,
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      getLocationsList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        ""
      );
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "vendor_id") {
      setRequest({
        ...request,
        vendor_id: "",
        audit_type: "",
      });
      getVendorList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        ""
      );
      setAuditTypeList([]);
    }
    if (name === "audit_type") {
      setRequest({
        ...request,
        audit_type: "",
      });
      getAuditTypeList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        getValue(request, `vendor_id`, ""),
        ""
      );
    }
  };

  const handleSelectFilter = (id: any, name: string) => {
    if (name === "region_id") {
      getGroupsList("", id, "");
    }
    if (name === "group_id") {
      getStatesList("", getValue(params, `region_id`, ""), id, "");
    }

    if (name === "state_id") {
      getCitiesList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        id,
        ""
      );
    }

    if (name === "city_id") {
      getLocationsList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        id,
        ""
      );
    }

    if (name === "location_id") {
      getVendorList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        id,
        ""
      );
    }

    if (name === "vendor_id") {
      getAuditTypeList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        id,
        ""
      );
    }

    setRequest({
      ...request,
      [name]: id,
    });
  };

  const handleSubmitSmartFilter = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      city_id: getValue(request, `city_id`, ""),

      region_id: getValue(request, `region_id`, ""),
      group_id: getValue(request, `group_id`, ""),
      location_id: getValue(request, `location_id`, ""),
      vendor_id: getValue(request, `vendor_id`, ""),
      audit_type: getValue(request, `audit_type`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    handleFilter();
  };

  let state_ID =
    getValue(stateList, `length`, 0) > 0 &&
    stateList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );

  let city_ID =
    getValue(cityList, `length`, 0) > 0 &&
    cityList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `city_id`, "")
    );
  let region_ID =
    getValue(regionList, `length`, 0) > 0 &&
    regionList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `region_id`, "")
    );

  let group_ID =
    getValue(groupsList, `length`, 0) > 0 &&
    groupsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `group_id`, "")
    );

  let location_ID =
    getValue(locationsList, `length`, 0) > 0 &&
    locationsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `location_id`, "")
    );

  let vendor_ID =
    getValue(vendorsList, `length`, 0) > 0 &&
    vendorsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `vendor_id`, "")
    );

  let audit_type_ID =
    getValue(auditTypeList, `length`, 0) > 0 &&
    auditTypeList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `audit_type`, "")
    );

  /* -------------------------------------------------------------------------- */
  /*                                Chart section                               */
  /* -------------------------------------------------------------------------- */

  const handleChangeView = (view: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      view: view,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const [chartData, setChartData] = useState<any>({
    labels: [],
    datasets: [
      // {
      //   label: "Sites",
      //   data: [0],
      //   backgroundColor: "rgba(53, 162, 235, 0.5)",
      // },
      {
        label: "Vendors",
        data: [0],
        backgroundColor: "rgba(200, 162, 255, 0.5)",
      },
      // {
      //   label: "Headcount",
      //   data: [0],
      //   backgroundColor: "rgba(255, 199, 132, 0.5)",
      // },
      {
        label: "Overall Score (%)",
        data: [0],
        backgroundColor: "rgba(255, 99, 132, 0.2)",
      },
    ],
  });

  const handleOnClickBarChart = (index: number) => {
    let selectedList = list.filter((_item: any, i: number) => index === i);
    let item = getValue(selectedList, `[${0}]`, "");
    const locationID = getValue(item, `location_id`, "");
    const updatedQueryRequest = `${mainQueryRequest}&location_id=${locationID}`;
    navigate(`/audit/manage-audit/vendor?${updatedQueryRequest}`);

    // navigate(
    //   `/audit/manage-audit/vendor/${getValue(
    //     mainParams,
    //     `region_id`,
    //     ""
    //   )}/${getValue(params, `group_id`, "")}/${getValue(
    //     item,
    //     `location_id`,
    //     ""
    //   )}?${mainQueryRequest}`
    // );
  };

  const options = {
    responsive: true,
    plugins: {
      datalabels: {
        labels: {
          value: {
            color: "black",
            font: {
              size: 13,
            },
          },
        },
        formatter: (val: any) => {
          // return val ? `${val}${val ? "%" : ""}` : "";
          return val;
        },
      },
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: "Location Level Breakup",
      },
    },
  };

  /* -------------------------------------------------------------------------- */
  /*                            Download Reports                                */
  /* -------------------------------------------------------------------------- */
  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      type: params.type ? params.type : "LOCATION",
      audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: true,
      user_id: getValue(user, `id`, ""),
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });

    let queryRequest = QueryRequestHelper(payload);
    setDownloadLoading(true);
    try {
      let resp = await exportManageAudit(queryRequest);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        handleDownloadOnClick(
          getValue(resp, `data.downloadUrl`, ""),
          "Manage Audit"
        );
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "audit_manage_audit"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              multi={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleRemoveNavItems={handleRemoveNavItems}
            />
          )}
          <div className="dashboard-wrapper__header d-flex justify-content-between d-none">
            <div className="d-flex align-items-center">
              <NavLink
                to={`/audit/manage-audit/group/${getValue(
                  mainParams,
                  `region_id`,
                  ""
                )}?${mainQueryRequest}`}
              >
                <img
                  src="/images/back-link.svg"
                  className="img-fluid ml-5"
                  height={24}
                  width={24}
                />
              </NavLink>
              &nbsp;&nbsp;&nbsp;
              <h4 className="dashbaord-wrapper__header-title">
                Group -{" "}
                <span style={{ color: "#276ef2" }}>
                  {getValue(selectedOption, `group_name`, "")}
                </span>
              </h4>
            </div>
            <div className="d-flex align-items-center">
              <div
                className="d-flex cursor-pointer"
                onClick={() =>
                  handleChangeView(!getValue(params, `view`, "") ? "graph" : "")
                }
              >
                <img
                  src={`/images/${
                    getValue(params, `view`, "") === "graph"
                      ? "list"
                      : "bar_graph"
                  }.png`}
                  style={{ height: "30px", width: "30px", marginRight: "20px" }}
                />
              </div>
              <CalenderDropdown
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
                disableDate
              />
            </div>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <NavLink
                to="#"
                onClick={(e: any) => {
                  e.preventDefault(); // Prevent default navigation behavior
                  window.history.back();
                }}
              >
                <img
                  src="/images/back-link.svg"
                  className="img-fluid ml-5 me-2"
                  height={24}
                  width={24}
                />
              </NavLink>

              <div className="header-parent-icon-holder">
                <MenuAuditSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Manage Audit
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  {params.view_type === "VENDOR" ? "Vendor" : "Group"} -{" "}
                  <span style={{ color: "#276ef2" }}>
                    {params.view_type === "VENDOR"
                      ? getValue(selectedOption, `vendor_name`, "")
                      : getValue(selectedOption, `group_name`, "")}
                  </span>
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <div
                className="d-flex cursor-pointer d-none"
                onClick={() =>
                  handleChangeView(!getValue(params, `view`, "") ? "graph" : "")
                }
              >
                <img
                  src={`/images/${
                    getValue(params, `view`, "") === "graph"
                      ? "list"
                      : "bar_graph"
                  }.png`}
                  style={{ height: "30px", width: "30px", marginRight: "20px" }}
                />
              </div>
              <RightMenuHeaders
                monthYear={true}
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //smartFilter
                smartFilter={false}
                handleFilter={handleFilter}
                //Line Seperator of button
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
                // download section
                downloadSelfComplianceReport={true}
                handleDownloadSelfComplianceReport={
                  handleDownloadSelfComplianceReport
                }
                downloadLoading={downloadLoading}
              />
            </div>
          </div>

          <div className="main-page-layout-wrapper">
            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/location/detail"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  smartFilter={true}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  add="false"
                  isFilterVisible={isFilterVisible}
                />
              </div>
              {/* {isFilterVisible && ( */}
              <ManageAuditFilterForm
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                reset={reset}
                handleSubmitSmartFilter={handleSubmitSmartFilter}
                //region
                regionLoading={regionLoading}
                regionList={regionList}
                region_ID={region_ID}
                getRegionsList={getRegionsList}
                disableRegion
                //group
                groupLoading={groupLoading}
                groupsList={groupsList}
                group_ID={group_ID}
                getGroupsList={getGroupsList}
                disableGroup
                //state
                stateLoading={stateLoading}
                stateList={stateList}
                state_ID={state_ID}
                getStatesList={getStatesList}
                //city
                cityLoading={cityLoading}
                cityList={cityList}
                city_ID={city_ID}
                getCitiesList={getCitiesList}
                //location
                locationLoading={locationLoading}
                locationsList={locationsList}
                location_ID={location_ID}
                getLocationsList={getLocationsList}
                //configuration/vendors
                vendorLoading={vendorLoading}
                vendorsList={vendorsList}
                vendor_ID={vendor_ID}
                getVendorList={getVendorList}
                //audit_type
                auditTypeLoading={auditTypeLoading}
                auditTypeList={auditTypeList}
                audit_type_ID={audit_type_ID}
                getAuditTypeList={getAuditTypeList}
                //above common funs
                request={request}
                handleSelectFilter={handleSelectFilter}
                handleRemoveFilter={handleRemoveFilter}
                hideReset
                filterIsOpen={filterIsOpen}
                handleFilter={handleFilter}
                moduleName={"Audit"}
                subModuleName={"Manage Audit - Group"}
              />
              {/* )} */}
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list.length > 0 ? (
                <>
                  {getValue(params, `view`, "") === "graph" ? (
                    <div className="manage_audit_chart-view">
                      <Bar
                        data={chartData}
                        options={{
                          ...options,
                          responsive: true,
                          maintainAspectRatio: true,
                          onClick: function (evt, element) {
                            let ind = getValue(element, `[${0}].index`, null);
                            if (element.length > 0) {
                              handleOnClickBarChart(ind);
                            }
                          },
                        }}
                      />
                    </div>
                  ) : (
                    <ScrollableReactTable
                      columns={columns}
                      data={list}
                      getTableState={getTableState}
                      rowClick={rowClick}
                      check={check}
                      selectedIDs={selectedIDs}
                      getTrProps={getTrProps}
                      checkboxlogo
                    />
                  )}
                </>
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <ManageAuditNotfound />
                    </>
                  ) : (
                    <ManageAuditNotfound />
                  )}
                </>
              )}
            </div>
            <FooterWrapper
              list={list}
              totalCount={totalCount}
              limit={limit}
              page_no={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
              hideCount
            />
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default ManageAuditLocations;